import type { JSX } from "react";
import { useLocation } from "react-router-dom";

export const EVENT_FORM_UNAVAILABLE_NOTE =
  "This code belongs to an event form you cannot open, so its record is shown instead.";

/** The scan landing's one line note (spec "Barcode landing"); router state, so it never survives a reload or a shared link. */
export default function EventFormUnavailableNote(): JSX.Element | null {
  const { state } = useLocation();
  const show =
    (state as { eventFormUnavailable?: unknown } | null)
      ?.eventFormUnavailable === true;
  if (!show) return null;
  return (
    <p role="status" className="mt-2 text-sm text-gray-700">
      {EVENT_FORM_UNAVAILABLE_NOTE}
    </p>
  );
}
